import React from 'react';
import { Skeleton } from '@mui/material';
import { CustomerDetail } from '../../models';

function CustomerInfoSkeleton({ isLoading, children, customerDetail }: CustomerInfoSkeletonProps) {
  return isLoading || (!isLoading && !customerDetail?.customerName) ? <Skeleton variant="text" sx={{ fontSize: '20px' }} /> : (
    <>
      {' '}
      {children}
      {' '}
    </>
  );
}

export interface CustomerInfoSkeletonProps {
  isLoading: boolean;
  customerDetail: CustomerDetail | undefined;
  children: React.ReactNode;
}

export { CustomerInfoSkeleton };
